
import {Euler, Vector3,Scene} from "three";

const FLOOR_NUMBER = {
    BOTTOM_FLOOR: 1,
    TOP_FLOOR:2,
};
// Here we split by Artists Names
const CameraLocationsDB = [

    {
        cameraLocationId: 'W2T1',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Anne Valverde',
        cameraPosition: null, // use THREE.Vector3
        cameraRotation: null,  //use THREE.Euler
        cameraPositionMobile: null, // use THREE.Vector3
        cameraRotationMobile: null,  //use THREE.Euler

    },
    {
        cameraLocationId: 'W4T1',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Christine Flynn',
        cameraPosition: null,
        cameraPositionMobile: null, // use THREE.Vector3
        cameraRotationMobile: null,  //use THREE.Euler

    },
    {
        cameraLocationId: 'W3T2',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Corinne Dalle Ore',
        cameraPosition: null,
        cameraRotation: new Euler(-Math.PI,Math.PI/6.5,-Math.PI),
        cameraPositionMobile: null, // use THREE.Vector3
        cameraRotationMobile: null,  //use THREE.Euler

    },
    {
        cameraLocationId: 'W3T1',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Emily Filler',
        cameraPosition: null,
        cameraRotation: new Euler(-Math.PI,Math.PI/6.5,-Math.PI),
        cameraPositionMobile: null, // use THREE.Vector3
        cameraRotationMobile: null,  //use THREE.Euler


    },
    {
        cameraLocationId: 'W1T1',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Joseph',
        cameraPosition: null,
        cameraPositionMobile: null, // use THREE.Vector3
        cameraRotationMobile: null,  //use THREE.Euler

    },
    {
        cameraLocationId: 'W8BT1',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Laurence De Valmy',
        cameraPosition: null,
        cameraPositionMobile: null, // use THREE.Vector3
        cameraRotationMobile: null,  //use THREE.Euler

    },
    {
        cameraLocationId: 'W8AT1',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Philippe Ringot',
        cameraPosition: null,
        cameraRotation: new Euler(0,Math.PI *0.1,0),
        cameraPositionMobile: null, // use THREE.Vector3
        cameraRotationMobile: null,  //use THREE.Euler

    },
    {
        cameraLocationId: 'W2T2',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Sam Peacock',
        cameraPosition: null,
        cameraPositionMobile: null, // use THREE.Vector3
        cameraRotationMobile: null,  //use THREE.Euler

    },
];

export {CameraLocationsDB, FLOOR_NUMBER};
